import { _ } from '/@/locale';
import styles from './styles.module.css';

export const LegalText = ({ config }) => {
    return (
        <div className={styles.root}>
            {_(config.legalText)
                .split('\n')
                .map((text, index) => (
                    <p key={index}>{text}</p>
                ))}
        </div>
    );
};
